import React, { PropTypes } from 'react/addons';
import cx from 'classnames';

const DateComponent = React.createClass({
  propTypes: {
    date: PropTypes.instanceOf(Date),
    enabled: PropTypes.bool,
    selected: PropTypes.bool,
    notInMonth: PropTypes.bool,
    isWeekend: PropTypes.bool,
  },

  render() {
    const {
      date,
      enabled,
      selected,
      notInMonth,
      isWeekend,
    } = this.props;

    const classes = cx({
      'ofs-Calendar__Date': true,
      'ofs-Calendar__Date--is-enabled': enabled,
      'ofs-Calendar__Date--is-disabled': !enabled,
      'ofs-Calendar__Date--not-in-month': notInMonth,
      'ofs-Calendar__Date--is-selected': selected,
      'ofs-Calendar__Date--is-weekend': isWeekend,
    });

    return (
      <td className={classes} {...this.props}>
        <div className="ofs-Calendar__DateHighlight"></div>
        <div className="ofs-Calendar__DateSelected">{date.getDate()}</div>
        <div className="ofs-Calendar__DateValue">{date.getDate()}</div>
      </td>
    );
  }
});

export default DateComponent;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/Calendar/DateComponent.jsx
 **/